import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

import NavigationItem from '../NavigationItem';
import SearchButton from '../SearchButton';
import SocialLink from '../SocialLink';

export default class HeaderNavigation extends Component {
  _openSearch() {
    this.props.openSearch();
  }

  render() {
    return (
      <div className={css(styles.container)}>
        <NavigationItem title="Music" url="/music" />
        <NavigationItem title="Features" url="/features" />
        <NavigationItem title="Interviews" url="/interviews" />
        <NavigationItem title="Contact" url="/contact" />
        <SearchButton handler={this._openSearch.bind(this)} visible={this.props.showSearch} />
        <SocialLink type='facebook' />
        <SocialLink type='twitter' />
        <SocialLink type='instagram' />
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'row'
  }
})



// WEBPACK FOOTER //
// ./src/components/HeaderNavigation/index.js